var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionlocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51239 14.0821C4.28896 14.8251 5.28645 15.2 6.27725 15.2C7.26804 15.2 8.26553 14.8251 9.0421 14.0821C11.017 12.1808 13.1994 9.15486 12.3827 5.54649C11.6396 2.26616 8.78101 0.800049 6.28394 0.800049H6.27725C3.78018 0.800049 0.9216 2.26616 0.178504 5.5398C-0.644926 9.14816 1.5375 12.1808 3.51239 14.0821ZM1.1626 5.76072C1.82537 2.84189 4.32913 1.80423 6.27725 1.80423C8.22536 1.80423 10.7358 2.84189 11.4053 5.76072C12.1149 8.91385 10.1333 11.6318 8.34586 13.3523C7.18771 14.4703 5.37348 14.4703 4.21532 13.3523C2.42118 11.6318 0.439592 8.91385 1.1626 5.76072ZM3.68643 6.85858C3.68643 8.29122 4.85128 9.44938 6.27722 9.44938C7.70316 9.44938 8.86801 8.29791 8.86801 6.86528C8.86801 5.43264 7.70316 4.27449 6.27722 4.27449C4.85128 4.27449 3.68643 5.42595 3.68643 6.85858ZM4.69061 6.86528C4.69061 5.98829 5.40693 5.27867 6.27722 5.27867C7.14751 5.27867 7.86383 5.98829 7.86383 6.86528C7.86383 7.74226 7.15421 8.45189 6.27722 8.45189C5.40023 8.45189 4.69061 7.74226 4.69061 6.86528Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionlocation);
export default __webpack_public_path__ + "static/media/Unionlocation.045d3db32f5e2722c737d7364fb12e10.svg";
export { ForwardRef as ReactComponent };